/**
 * Runtime `window.configs` (see public/index.html placeholder) can override env.
 * For VUE_APP_API_BASE_URL we must not let injected localhost win on a real deployed host,
 * or the UI will call 127.0.0.1 from users' browsers (ERR_CONNECTION_REFUSED).
 */
export default function getEnv(name) {
	const fromProcess = process.env[name]
	const fromConfigs = typeof window !== "undefined" && window.configs ? window.configs[name] : undefined

	if (name === "VUE_APP_API_BASE_URL" && typeof window !== "undefined") {
		const h = window.location.hostname
		const deployed = h && h !== "localhost" && h !== "127.0.0.1"
		if (deployed) {
			return fromProcess
		}
	}

	// Preserve empty string from process.env; do not fall back with || (empty is valid for same-origin API).
	const hasConfigs = typeof fromConfigs !== "undefined" && fromConfigs !== null
	if (hasConfigs) {
		return fromConfigs
	}
	return fromProcess
}
